<template>
  <div>
    <div style="line-height: 15px" class="p-2">
      <br />
      <label>Status:</label>
      <p style="line-height: 25px; color: green !important; font-weight: bold" v-if="sys_controll.mail_service_status == 'Online'">
        {{ sys_controll.mail_service_status }}
      </p>
      <p style="line-height: 25px; color: red !important; font-weight: bold" v-else>
        {{ sys_controll.mail_service_status }}
      </p>
      <!--
      <label>Última atualização:</label>
      <p style="line-height: 25px">
        {{ formatDate(sys_controll.updated_at) }}
      </p>
      -->
      <div class="row">
        <div class="progress-btn" data-progress-style="fill-back" @click="buscarLotes">
          <div class="btn update-btn">
            <i class="fa-solid fa-arrow-rotate-left"></i>
            Atualizar
          </div>
          <div class="progress"></div>
        </div>
      </div>
    </div>

    <!-- TABELA DE JOBS -->
    <div class="card" v-if="jobs.length && jobs.length >= 1">
      <div class="card-header">
        <h3 class="card-title">E-mails em processamento</h3>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover text-nowrap" style="position: relative">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Id</th>
              <th>Criação</th>
              <th>Atualização</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(job, index) in jobs" :key="job">
              <td data-label="Seq">{{ index + 1 }}</td>
              <td data-label="Id">{{ job.id }}</td>
              <td data-label="Criação">{{ formatDate(job.created_at) }}</td>
              <td data-label="Atualização">{{ formatDate(job.updated_at) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- TABELA DE EMAILS -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">E-mails enviados</h3>
        <div class="card-tools">
          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover text-nowrap" style="position: relative">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Assunto</th>
              <th>Destinatário</th>
              <th>Status</th>
              <th>Criação</th>
              <th>Atualização</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(email, index) in emails" :key="email">
              <td data-label="Seq">{{ index + 1 }}</td>
              <td data-label="Assunto">{{ email.subject }}</td>
              <td data-label="Destinatário">{{ email.recipient_email }}</td>
              <td data-label="Status">
                <label v-if="email.status == 'aguardando'">Aguardando</label>
                <label v-if="email.status == 'enviado'" style="color: green">Enviado</label>
                <label v-if="email.status == 'falha_no_envio'" style="color: red">Falha no envio</label>
              </td>
              <td data-label="Criação">{{ formatDate(email.created_at) }}</td>
              <td data-label="Atualização">{{ formatDate(email.updated_at) }}</td>
              <td data-label="Ações">
                <button
                  v-if="email.status == 'falha_no_envio'"
                  style="max-height: 40px"
                  type="submit"
                  class="btn btn-default"
                  @click="reenviar(email.id)"
                >
                  <i class="fa-solid fa-arrow-rotate-left"></i>
                  Reenviar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + lotes.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import sweetAlert from "../../controller/sweetAlert";

import ContextMenu from "primevue/contextmenu";

export default {
  props: ["sys_controll"],

  mixins: [sweetAlert],

  components: { Loading, ContextMenu },

  data() {
    return {
      isLoading: false,
      leilao_selecionado: "",
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      lotes: [],
      cidades: [],
      numero: "",
      estado: "",
      cidade: "",
      titulo: "",
      descricao: "",
      lotes: [],
      lote_selecionado: "",
      jobs: [],
    };
  },

  mounted() {
    console.log(this.leilao);
    this.buscarLotes();

    console.log("EMAILS");

    console.log(document.getElementById("newMenu"));

    this.searchForever();
  },

  methods: {
    searchForever() {
      let that = this;

      setTimeout(() => {
        that.buscarLotes();
        that.searchForever();
      }, 2000);
    },

    reenviar(email_id) {
      this.isLoading = true;

      let data = {
        email_id: email_id,
      };

      console.log(data);

      axios
        .post(`/admin/email/reenviar`, data)
        .then((response) => {
          this.showSuccessMessageWithButtonAndRedirect("Sucesso!", "Adicionado à fila de envio!", "/admin/emails");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeStatus(lote) {
      console.log(lote);

      let data = {
        lote_id: lote.id,
        lote_oculto: this.convertToTiny(lote.lote_oculto),
      };

      console.log(data);

      axios
        .post(`/admin/lote/atualizar_status`, data)
        .then((response) => {
          this.showSuccessMessage("Status atualizado");

          //window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    convertToTiny(value) {
      if (value) {
        return 1;
      } else {
        return 0;
      }
    },

    editarNumeroLote(lote) {
      console.log("Editando lote " + lote);
      lote.edit = false;

      let data = {
        lote_id: lote.id,
        leilao_id: lote.leilao_id,
        lote_numero: lote.numero_edit,
      };

      axios
        .post(`/admin/lote/update_lote_numero`, data)
        .then((response) => {
          if (response.data.success) {
            this.showSuccessMessage("Número atualizado");

            lote.lote_numero = lote.numero_edit;
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onRightClick(event, lote) {
      console.log("Lote selecionado");
      this.lote_selecionado = lote;
      //console.log(this.$refs.right_menu);

      //this.$refs.right_menu.show(event);

      let newMenu = document.getElementById("newMenu");

      let x = event.clientX - 300;
      let y = event.pageY - 350;

      let winWidth = window.innerWidth;
      let cmWidth = newMenu.offsetWidth;

      x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 300 : x;

      newMenu.style.top = y + "px";
      newMenu.style.left = x + "px";
      newMenu.style.visibility = "visible";
    },

    command() {},

    alterarStatusLote(lote) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja alterar o status do lote <br/><b>" + lote.lote_numero + "</b> ?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero alterar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              lote_id: lote.id,
              lote_status: lote.status_temp,
            };

            axios
              .post(`/admin/lote/atualizar_status`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessageWithButton("Status atualizado!");
              })
              .catch((error) => {
                this.showErrorMessageWithButton("Ops..", error);
                console.log(error);
              });
          } else {
            lote.status_temp = lote.lote_status;
          }
        });
    },

    getUrlAddLote(lote) {
      return "/admin/lote/" + lote.id + "/lotes/cadastrar_lote";
    },

    getUrlDocumentos(lote) {
      return "/admin/documentos/" + lote.leilao_id;
    },

    getUrlLogs(lote) {
      let id = lote ? lote.id : this.lote_selecionado.id;

      return "/admin/lote/" + id + "/logs";
    },

    limparFiltros() {
      this.numero = "";
      this.descricao = "";
      this.titulo = "";
      this.leilao_id = "";
      this.cidade = "";
      this.estado = "";

      this.buscarLotes();
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();
        return ~~days + " dias";
      } else {
        return ~~hours + " horas";
      }
    },

    visualizar(lote) {
      this.leilao_selecionado = lote;
    },

    formatToCompare(date) {
      return moment(date);
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    getUrlEdit(lote) {
      let id = lote ? lote.id : this.lote_selecionado.id;

      return "/admin/leilao/" + this.leilao.id + "/lotes/editar/" + id;
    },

    show(lote) {
      this.leilao_selecionado = lote;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarLotes();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarLotes();
      }
    },

    getUrlFotos(lote) {
      let id = lote ? lote.id : this.lote_selecionado.id;

      return "/admin/fotos/" + id + "";
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.estado,
      };

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.cidades = response.data.cidades;

          console.log(response.data);

          this.isLoading = false;

          this.buscarLotes();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    buscarLotes() {
      this.isLoading = true;

      let data = {
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      console.log(data);

      axios
        .post(`/admin/emails/search`, data)
        .then((response) => {
          this.emails = response.data.emails;
          this.total = response.data.total;

          this.jobs = response.data.jobs;

          console.log("emails");
          console.log(this.emails);
          console.log(response.data);

          this.pagination(response.data);
        })
        .catch((error) => {
          console.log(error);
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    getImagePath(logo) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.path + "/" + logo.arquivo;
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarLotes();
    },

    deletar(lote) {
      this.leilao_selecionado = lote;

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar o tipo de lote<b><br/>" + this.leilao_selecionado.nome + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.leilao_selecionado.id,
            };

            axios
              .post(`/admin/lote/delete`, data)
              .then((response) => {
                this.showSuccessMessage("lote deletado!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.leilao_selecionado.id,
        cadastro_tipo: this.leilao_selecionado.cadastro_tipo,
        tipodoc: this.leilao_selecionado.tipodoc,
        estado_civil: this.leilao_selecionado.estado_civil,
        obrigatorio: this.leilao_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.progress-btn {
  position: relative;
  width: 150px;
  height: 40px;
  display: inline-block;
  font-family: "RobotoDraft", "Roboto", sans-serif;
  color: #fff !important;
  font-weight: normal;
  font-size: 20px;
  transition: all 0.4s ease;
  border: 2px solid white;
}
.progress-btn:not(.active) {
  cursor: pointer;
}

.progress-btn .btn {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  line-height: 5px;
  text-align: center;
  z-index: 10;
  opacity: 1;
}

.progress-btn .progress {
  width: 0%;
  z-index: 5;
  background: #1d743a;
  opacity: 0;
  transition: all 0.3s ease;
  height: 5px;
}

.progress-btn .progress {
  opacity: 1;
  animation: progress-anim 2s ease infinite;
}

.progress-btn[data-progress-style="fill-back"] .progress {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}

@keyframes progress-anim {
  0% {
    width: 0%;
  }
  5% {
    width: 0%;
  }
  10% {
    width: 15%;
  }
  30% {
    width: 40%;
  }
  50% {
    width: 55%;
  }
  80% {
    width: 100%;
  }
  95% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}

.span-green {
  background-color: green;
}

.span-grwy {
  background-color: gray;
}

.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
